/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Payments_DescriptionInputs */

const en_settings_payments_description = /** @type {(inputs: Settings_Payments_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your payment history`)
};

/**
* | output |
* | --- |
* | "Your payment history" |
*
* @param {Settings_Payments_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_payments_description = /** @type {((inputs?: Settings_Payments_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Payments_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_payments_description(inputs)
});
export { settings_payments_description as "settings.payments.description" }